import device from '~/mixins/device.js'

export default {
  mixins: [device],

  props: {
    name: {
      type: String,
    },

    description: {
      type: String,
    },

    category: {
      type: String,
    },

    image: {
      type: Object,
    },

    video: {
      type: Object,
    },

    imageMobile: {
      type: Object,
    },

    custom: {
      type: Boolean,
    },
  },

  computed: {
    computedVideo() {
      return {
        ...this.video,
        image: this.imageMobile,
      }
    },

    customTheme() {
      return this.custom ? 'card-producer--custom' : ''
    },
  },
}
